import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { AdvancePaymentModel } from "./advancePayment.model";
import { AdvancePaymentService } from "./advancePayment.service";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { DocumentAssignService } from '../../../modules_v2/income/shared/services/document-assign.service';
import { ConfirmService } from '../../../modules_v2/shared/services/confirm.service';
import { ExpensesAdvancedPaymentConst } from '../const';
import { consts } from '../../../consts';
import { DummyComponent } from '../../../shared/dummy.component';
import { TableService } from '../../../shared/components/table/table.service';
import { Utils } from '../../../shared/utils';

@Component({
    selector: 'convfact-advancepayment-list',
    templateUrl: './advancePayment-list.component.html',
    styleUrls: ['./advancePayment.component.css'],
    standalone: false
})

export class AdvancePaymentListComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  dataResultTotals = null;

  constructor(
    private router: Router,
    private advancePaymentService: AdvancePaymentService,
    public dialog: MatDialog,
    public dummy: DummyComponent,
    public snackBar: MatSnackBar,
    private tableService: TableService,
    private documentAssign: DocumentAssignService,
    private confirm: ConfirmService
  ) { }

  isDataAvailable: boolean = false;
  dataSource: AdvancePaymentModel[] = [];
  empty: boolean = false;
  ready: boolean = false;

  headerTable: any[] = ExpensesAdvancedPaymentConst.headerTable;

  public create(): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.router.navigate(['/expense/advancepayment/create']);
  }

  public edit(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    const payment = this.dataSource.find(f => f.uid == uid);
    if (payment.invoiceUid == consts.EMPTY_GUID) {
      this.router.navigate(['/expense/advancepayment/edit/', uid]);
    } else {
      this.displayInfo("No es posible editar un adelanto que ya ha sido asignado.");
    }
  }

  public delete(uid: string) {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.confirm.open({
      title: 'Eliminar anticipo',
      message: '¿Seguro que quieres eliminar este anticipo? Esta acción no se puede deshacer.',
      tone: 'danger',
      confirmText: 'Eliminar',
      confirmIcon: 'delete',
      loadingText: 'Eliminando anticipo…',
      errorText: 'No se pudo eliminar el anticipo',
      action: () => this.advancePaymentService.deleteData(uid),
    }).subscribe(deleted => {
      if (deleted) this.dummy.redirectTo(this.router.url);
    });
  }

  public assignExpense(uid: string) {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    const payment = this.dataSource.find(f => f.uid == uid);
    if (payment.invoiceUid == consts.EMPTY_GUID) {
      this.documentAssign.assignSupplierAdvance({
        uid: uid,
        totalAmount: payment.total,
        providerUid: payment.providerUid,
        providerName: payment.providerName,
      }).subscribe(assigned => {
        if (assigned) this.dummy.redirectTo(this.router.url);
      })
    } else {
      this.displayInfo("No es posible asignar un adelanto que ya ha sido asignado.");
    }
  }

  public ngOnInit() {
    this.getList();
    this.getTotal();
  }

  public getList() {
    this.advancePaymentService.getList(this.currentPage, this.itemsPerPage).then(
      data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;
        this.ready = true;
        if (this.dataSource.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
      });
  }

  public pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  public getTotal() {
    this.advancePaymentService.getTotal().then(
      data => {
        this.dataResultTotals = data;
      }
    );
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

}
